<template>
    <div class="d-flex justify-content-start">
        <ul class="tree horizontal">
            <li>
                <div>{{ treeData.name.replaceAll("_", " ") }}</div>
                <ul>
                    <li v-for="child of treeData.children" :key="child.name">
                        <div style="width: 300px; cursor: pointer;" @click="$emit('toggle-children', child.name)">
                            <div class="d-flex justify-content-between align-items-center"
                                style="gap: 32px; font-weight: 600;">
                                <div class="text-capitalize">{{ child.name.replaceAll("_", " ") }}</div>
                                <div v-if="child.contribution_percentage" style="color: var(--primary_brand);">{{
                                    formatNumber(child.contribution_percentage) }}%</div>
                            </div>
                            <div class="d-flex justify-content-between"
                                style="gap: 6px; margin-top: 10px; font-family: Heebo; font-size: 12px; color: #5E5E5E;">
                                <div v-if="child.frequency" class="d-flex" style="gap: 10px;">
                                    <div>Frequency</div>
                                    <div>{{ child.frequency }}</div>
                                </div>
                                <div v-if="child.rank" class="d-flex" style="gap: 10px;">
                                    <div>Rank</div>
                                    <div>#{{ child.rank }}</div>
                                </div>
                            </div>
                        </div>
                        <ul v-if="child.showChildren">
                            <li v-for="grandChild of child.children" :key="grandChild.name">
                                <div style="width: 300px;">
                                    <div class="d-flex justify-content-between align-items-center"
                                        style="gap: 32px; font-weight: 600;">
                                        <div :title="grandChild.product_name"><a :href="grandChild.product_url" target="_blank" style="color: #050A13;">{{ grandChild.product_id }}</a></div>
                                        <div v-if="grandChild.contribution_percentage"
                                            style="color: var(--primary_brand);">{{ formatNumber(grandChild.contribution_percentage)
                                            }}%</div>
                                    </div>
                                    <div class="d-flex justify-content-between"
                                        style="gap: 6px; margin-top: 10px; font-family: Heebo; font-size: 12px; color: #5E5E5E;">
                                        <div v-if="grandChild.frequency" class="d-flex" style="gap: 10px;">
                                            <div>Frequency</div>
                                            <div>{{ grandChild.frequency }}</div>
                                        </div>
                                        <div v-if="grandChild.rank" class="d-flex" style="gap: 10px;">
                                            <div>Rank</div>
                                            <div>#{{ grandChild.rank }}</div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <ul v-else>
                            <li>
                                <div>{{ child.count }}</div>
                            </li>
                        </ul>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: 'KeywordTree',
    props: {
        treeData: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },
    data() {
        return {
        }
    },
    methods: {
        formatNumber(num) {
            if (Number.isInteger(num)) {
                return num.toString(); // Return as is for integers
            }
            return num.toFixed(2); // Format to 2 decimal places for non-integers
        }
    }

}
</script>
<style scoped>
.tree {
    margin: 18px;
    padding: 0;
}

.tree:not(:empty):before,
.tree:not(:empty):after,
.tree ul:not(:empty):before,
.tree ul:not(:empty):after,
.tree li:not(:empty):before,
.tree li:not(:empty):after {
    display: block;
    position: absolute;
    content: "";
}

.tree ul,
.tree li {
    position: relative;
    margin: 0;
    padding: 0;
    padding-left: 30px;
}

.tree li {
    list-style: none;
}

.tree li>div {
    background-color: white;
    color: #222;
    padding: 8px 24px;
    display: inline-block;
    text-align: center;
    border: 1px solid var(--primary_brand-60);
    border-radius: 5px;
}

.tree.horizontal li {
    display: flex;
    align-items: center;
    margin-left: 24px;
}

.tree.horizontal li>div {
    margin: 6px 0;
}

.tree.horizontal li:before {
    border-left: 1px solid var(--primary_brand-60);
    height: 100%;
    width: 0;
    top: 0;
    left: -12px;
    content: "";
}

.tree.horizontal li:first-child:before {
    height: 50%;
    top: 50%;
}

.tree.horizontal li:last-child:before {
    height: 50%;
    bottom: 50%;
    top: auto;
}

.tree.horizontal li:after,
.tree.horizontal ul:after {
    border-top: 1px solid var(--primary_brand-60);
    height: 0;
    width: 42px;
    top: 50%;
    left: -12px;
    content: "";
}

.tree.horizontal li:only-child:before {
    content: none;
}

.tree.horizontal ul:after {
    left: 0;
}

.tree.horizontal>li:only-child {
    margin-left: 0;
}

.tree.horizontal>li:only-child:before,
.tree.horizontal>li:only-child:after {
    content: none;
}
</style>
